import { render, staticRenderFns } from "./ItemsMenuPermission.vue?vue&type=template&id=07d853e5"
import script from "./ItemsMenuPermission.vue?vue&type=script&lang=js"
export * from "./ItemsMenuPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports